// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"7e96369a","376":"474d118f","812":"bc562ffc","875":"4d48684e"}[chunkId] + ".chunk.js";
};